import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Radio, Row } from 'antd';
import { Link } from 'react-router';
import TabProtect from './TabProtect';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
class MineIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSubmit}>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
          <Col md={8} sm={24}>
            <FormItem label="搜索条件">
              {getFieldDecorator('condition')(<Input placeholder="请输入关键字搜索" />)}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm()}</div>
          <div className="tableListOperator">
            <Row>
              <Col span={14}>
                <RadioGroup defaultValue="a">
                  <RadioButton value="a">保护客户</RadioButton>
                  <RadioButton value="b">签约客户</RadioButton>
                </RadioGroup>
              </Col>
              <Col span={10} style={{ textAlign: 'right' }}>
                <Link to="/crm/custom/add">
                  <Button>推荐给我</Button>
                </Link>
                <Link to="/client/manage/add">
                  <Button>我的佣金</Button>
                </Link>
                <Link to="/client/manage/add">
                  <Button>导出</Button>
                </Link>
                <Link to="/client/manage/add">
                  <Button style={{ marginRight: 0 }} type="primary">
                    新建客户
                  </Button>
                </Link>
              </Col>
            </Row>
          </div>
        </div>
        <TabProtect />
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(MineIndex);



// WEBPACK FOOTER //
// ./src/components/client/mine/Index.js